import React from 'react';
import { format_count } from '../common/constant/constant';


const TotalCountCard = ({
  title = "Total Clinics",
  count = "0",
  bgColor = "bg-blue-50",
  borderColor = "border-blue-100",
  textColor = "text-[#373737]",
  icondivBgColor = "bg-[#D1D6FF]",
  iconColor = "text-blue-600",
  iconBgColor = "bg-[#546DFE]",
  loading,
}) => {
  function formatCount(count) {
    return count < 10 ? `0${count}` : `${count}`;
  }

  return (
    <div className={`p-[2px] rounded-lg border ${borderColor} font-mont`}>
      <div
        className={`flex items-center justify-between p-4 ${bgColor} rounded-lg shadow-sm`}
      >
        {/* Text Section */}
        <div>
          <p className="font-mont font-[400] text-[20px] text-[#1B2A3D]">
            {title}
          </p>
          <h1
            className={`text-3xl font-[500] ${textColor} text-[40px] mt-[10px]`}
          >
            {loading ? (
              <div className="mini-spinner mt-3"></div>
            ) : (
              format_count(count)
            )}
          </h1>
        </div>
        {/* Icon Section */}
        <div
          className={`flex items-center justify-center w-12 h-12 ${icondivBgColor} rounded-lg`}
        >
          <div className={` ${iconBgColor} p-1 rounded-lg`}>
            {title == "Locations" ? (
              <svg
                width="24"
                height="23"
                viewBox="0 0 24 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_16711_86415)">
                  <path
                    d="M14.3514 1.96256L14.3513 1.96251C13.6538 1.49751 12.8414 1.25 12.0015 1.25C11.1615 1.25 10.3491 1.49751 9.65157 1.96251L9.65149 1.96256L4.13498 5.6412C4.1349 5.64125 4.13483 5.6413 4.13476 5.64135C2.95254 6.42843 2.25 7.74613 2.25 9.16341V16.8059C2.25 18.9827 4.01731 20.75 6.19406 20.75H17.8088C19.9856 20.75 21.7529 18.9827 21.7529 16.8059V9.16341C21.7529 7.74499 21.0466 6.42813 19.8688 5.64178L19.8684 5.64154L14.3514 1.96256Z"
                    stroke="white"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M14.7753 10.9037H12.8395V8.9679C12.8395 8.43555 12.4039 8 11.8716 8C11.3392 8 10.9037 8.43555 10.9037 8.9679V10.9037H8.9679C8.43555 10.9037 8 11.3392 8 11.8716C8 12.4039 8.43555 12.8395 8.9679 12.8395H10.9037V14.7753C10.9037 15.3076 11.3392 15.7432 11.8716 15.7432C12.4039 15.7432 12.8395 15.3076 12.8395 14.7753V12.8395H14.7753C15.3076 12.8395 15.7432 12.4039 15.7432 11.8716C15.7432 11.3392 15.3076 10.9037 14.7753 10.9037Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_16711_86415"
                    x="-2.5"
                    y="0.5"
                    width="29"
                    height="29"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_16711_86415"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_16711_86415"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            ) : title == "Trials" ? (
              <svg
                width="20"
                height="22"
                viewBox="0 0 20 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.06107 20.0451L3.64886 19.2361L3.06107 20.0451ZM1.95491 18.9389L2.76393 18.3511L1.95491 18.9389ZM18.0451 18.9389L17.2361 18.3511L18.0451 18.9389ZM16.9389 20.0451L16.3511 19.2361L16.9389 20.0451ZM16.9389 1.95491L17.5267 1.1459L16.9389 1.95491ZM18.0451 3.06107L17.2361 3.64886L18.0451 3.06107ZM3.06107 1.95491L3.64886 2.76393L3.06107 1.95491ZM1.95491 3.06107L2.76393 3.64886L1.95491 3.06107ZM11.1461 5.59531L11.3026 6.583H11.3026L11.1461 5.59531ZM9.5818 5.59531L9.42536 6.583H9.42536L9.5818 5.59531ZM6 14C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16V14ZM14 16C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14V16ZM6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12V10ZM9 12C9.55229 12 10 11.5523 10 11C10 10.4477 9.55229 10 9 10V12ZM18 10V12H20V10H18ZM2 12V10H0V12H2ZM10 20C8.10286 20 6.76033 19.9986 5.72497 19.8865C4.70833 19.7763 4.10714 19.569 3.64886 19.2361L2.47329 20.8541C3.32933 21.4761 4.32274 21.7462 5.50955 21.8748C6.67764 22.0014 8.14741 22 10 22V20ZM0 12C0 13.8526 -0.00137258 15.3224 0.125182 16.4905C0.253765 17.6773 0.523946 18.6707 1.1459 19.5267L2.76393 18.3511C2.43097 17.8929 2.22369 17.2917 2.11355 16.275C2.00137 15.2397 2 13.8971 2 12H0ZM3.64886 19.2361C3.30928 18.9894 3.01065 18.6907 2.76393 18.3511L1.1459 19.5267C1.51598 20.0361 1.96392 20.484 2.47329 20.8541L3.64886 19.2361ZM18 12C18 13.8971 17.9986 15.2397 17.8865 16.275C17.7763 17.2917 17.569 17.8929 17.2361 18.3511L18.8541 19.5267C19.4761 18.6707 19.7462 17.6773 19.8748 16.4905C20.0014 15.3224 20 13.8526 20 12H18ZM10 22C11.8526 22 13.3224 22.0014 14.4905 21.8748C15.6773 21.7462 16.6707 21.4761 17.5267 20.8541L16.3511 19.2361C15.8929 19.569 15.2917 19.7763 14.275 19.8865C13.2397 19.9986 11.8971 20 10 20V22ZM17.2361 18.3511C16.9894 18.6907 16.6907 18.9893 16.3511 19.2361L17.5267 20.8541C18.0361 20.484 18.484 20.0361 18.8541 19.5267L17.2361 18.3511ZM20 10C20 8.14741 20.0014 6.67764 19.8748 5.50955C19.7462 4.32274 19.4761 3.32933 18.8541 2.47329L17.2361 3.64886C17.569 4.10714 17.7763 4.70833 17.8865 5.72497C17.9986 6.76033 18 8.10286 18 10H20ZM16.3511 2.76393C16.6907 3.01065 16.9894 3.30928 17.2361 3.64886L18.8541 2.47329C18.484 1.96392 18.0361 1.51597 17.5267 1.1459L16.3511 2.76393ZM2 10C2 8.10286 2.00137 6.76033 2.11355 5.72497C2.22369 4.70833 2.43097 4.10714 2.76393 3.64886L1.1459 2.47329C0.523946 3.32933 0.253765 4.32274 0.125182 5.50955C-0.00137258 6.67764 0 8.14741 0 10H2ZM2.47329 1.1459C1.96392 1.51598 1.51598 1.96392 1.1459 2.47329L2.76393 3.64886C3.01065 3.30928 3.30928 3.01065 3.64886 2.76393L2.47329 1.1459ZM10.9897 4.60762C10.5751 4.67328 10.1528 4.67328 9.73823 4.60762L9.42536 6.583C10.0472 6.68149 10.6807 6.68149 11.3026 6.583L10.9897 4.60762ZM6 16H14V14H6V16ZM6 12H9V10H6V12ZM15.7336 0.943994C14.4904 2.18638 13.5977 3.06466 12.8309 3.66849C12.0791 4.2606 11.5286 4.52227 10.9897 4.60762L11.3026 6.583C12.3092 6.42356 13.1749 5.94336 14.0684 5.23974C14.9469 4.54784 15.9286 3.57654 17.1473 2.35871L15.7336 0.943994ZM10 2C11.6655 2 12.9073 2.00071 13.8953 2.07835C14.88 2.15573 15.5143 2.30428 15.9902 2.54425L16.8907 0.758453C16.0749 0.347075 15.1394 0.16995 14.052 0.0844928C12.9678 -0.000705242 11.6353 0 10 0V2ZM15.9902 2.54425C16.1188 2.60909 16.2381 2.68181 16.3511 2.76393L17.5267 1.1459C17.325 0.999363 17.1135 0.870804 16.8907 0.758453L15.9902 2.54425ZM3.36513 2.14331C4.65196 3.43009 5.67598 4.45299 6.5822 5.1783C7.50315 5.91539 8.38978 6.41898 9.42536 6.583L9.73823 4.60762C9.18385 4.51982 8.61742 4.24551 7.83193 3.61684C7.03171 2.97637 6.09593 2.04563 4.77931 0.729066L3.36513 2.14331ZM10 0C8.56625 0 7.36819 -0.000356555 6.37071 0.0561225C5.37419 0.112547 4.507 0.228315 3.74605 0.490877L4.39839 2.3815C4.90159 2.20787 5.55439 2.10555 6.48377 2.05292C7.41218 2.00036 8.54594 2 10 2V0ZM3.74605 0.490877C3.28435 0.650183 2.8628 0.862905 2.47329 1.1459L3.64886 2.76393C3.86358 2.60793 4.10548 2.48257 4.39839 2.3815L3.74605 0.490877Z"
                  fill="white"
                />
              </svg>
            ) : title == "Patients" ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : title == "Recruiters" ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 4C9.92893 4 8.25 5.67893 8.25 7.75C8.25 9.82107 9.92893 11.5 12 11.5C14.0711 11.5 15.75 9.82107 15.75 7.75C15.75 5.67893 14.0711 4 12 4ZM9.75 7.75C9.75 6.50736 10.7574 5.5 12 5.5C13.2426 5.5 14.25 6.50736 14.25 7.75C14.25 8.99264 13.2426 10 12 10C10.7574 10 9.75 8.99264 9.75 7.75Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9 13C6.92893 13 5.25 14.6789 5.25 16.75C5.25 18.8211 6.92893 20.5 9 20.5H15C17.0711 20.5 18.75 18.8211 18.75 16.75C18.75 14.6789 17.0711 13 15 13H9ZM6.75 16.75C6.75 15.5074 7.75736 14.5 9 14.5H15C16.2426 14.5 17.25 15.5074 17.25 16.75C17.25 17.9926 16.2426 19 15 19H9C7.75736 19 6.75 17.9926 6.75 16.75Z"
                  fill="white"
                />
                <path
                  d="M7.75214 10.3887C7.59441 10.1353 7.29846 10 7 10C5.75736 10 4.75 8.99264 4.75 7.75C4.75 6.50736 5.75736 5.5 7 5.5C7.29846 5.5 7.59441 5.36473 7.75214 5.11135C7.75912 5.10014 7.76613 5.08896 7.7732 5.07782C8.0358 4.66331 7.90275 4.0764 7.415 4.0227C7.27873 4.0077 7.14027 4 7 4C4.92893 4 3.25 5.67893 3.25 7.75C3.25 9.82107 4.92893 11.5 7 11.5C7.14027 11.5 7.27873 11.4923 7.415 11.4773C7.90275 11.4236 8.0358 10.8367 7.7732 10.4222C7.76614 10.411 7.75912 10.3999 7.75214 10.3887Z"
                  fill="white"
                />
                <path
                  d="M4.70829 18.3169C4.59477 18.1275 4.39439 18 4.17359 18H4C2.75736 18 1.75 16.9926 1.75 15.75C1.75 14.5074 2.75736 13.5 4 13.5H4.17359C4.39439 13.5 4.59477 13.3725 4.70829 13.1831C4.98539 12.7208 4.68468 12 4.14569 12H4C1.92893 12 0.25 13.6789 0.25 15.75C0.25 17.8211 1.92893 19.5 4 19.5H4.14569C4.68469 19.5 4.98539 18.7792 4.70829 18.3169Z"
                  fill="white"
                />
                <path
                  d="M16.2268 10.4222C15.9642 10.8367 16.0973 11.4236 16.585 11.4773C16.7213 11.4923 16.8597 11.5 17 11.5C19.0711 11.5 20.75 9.82107 20.75 7.75C20.75 5.67893 19.0711 4 17 4C16.8597 4 16.7213 4.0077 16.585 4.0227C16.0973 4.0764 15.9642 4.66331 16.2268 5.07782C16.2339 5.08896 16.2409 5.10014 16.2479 5.11134C16.4056 5.36472 16.7015 5.5 17 5.5C18.2426 5.5 19.25 6.50736 19.25 7.75C19.25 8.99264 18.2426 10 17 10C16.7015 10 16.4056 10.1353 16.2479 10.3887C16.2409 10.3999 16.2339 10.411 16.2268 10.4222Z"
                  fill="white"
                />
                <path
                  d="M19.2917 18.3169C19.0146 18.7792 19.3153 19.5 19.8543 19.5H20C22.0711 19.5 23.75 17.8211 23.75 15.75C23.75 13.6789 22.0711 12 20 12H19.8543C19.3153 12 19.0146 12.7208 19.2917 13.1831C19.4052 13.3725 19.6056 13.5 19.8264 13.5H20C21.2426 13.5 22.25 14.5074 22.25 15.75C22.25 16.9926 21.2426 18 20 18H19.8264C19.6056 18 19.4052 18.1275 19.2917 18.3169Z"
                  fill="white"
                />
              </svg>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalCountCard;
